//external imports
import { useState } from 'react';
import { MdDescription, MdWarning } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Button as ChakraButton } from '@chakra-ui/react';

//internal imports
import { Icon } from '@/components/v4';
import { useQuery } from 'hooks/useCustomQuery';
import getCompany from 'API/Company/getCompany';
import CompanyApprovalModal from 'pages/organisations/companies/v5/modals/CompanyApprovalModal';
import walkthroughIds from './walkthroughIds';

const CompanyStatus = () => {
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });

    const { requiredScope } = useSelector((state) => state.login);

    const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);

    const { data: companyStatus } = useQuery({
        queryKey: ['company', currentCompany],
        queryFn: async () => {
            return getCompany(currentCompany);
        },
        enabled: !!currentCompany,
        refetchOnWindowFocus: false,
    });

    if (!companyStatus) {
        return null;
    }

    const showPendingApproval = !companyStatus.approved;

    return (
        <>
            {Object.keys(companyStatus).includes('isActive') &&
                !companyStatus.isActive && (
                    <>
                        <Icon as={MdWarning} sx={{ boxSize: '24px' }} />{' '}
                        Inactive Company &nbsp;
                    </>
                )}

            {showPendingApproval && requiredScope > 20 && (
                <ChakraButton
                    style={{
                        textTransform: 'none',
                        minHeight: '40px',
                        fontWeight: '400',
                        backgroundColor: 'transparent',
                        color: 'white',
                        borderRadius: '.375rem',
                    }}
                    borderColor="var(--chakra-colors-dark-tcap-borderGray)"
                    _hover={{
                        borderColor: 'gray.300',
                    }}
                    variant="outline"
                    onClick={() => setIsApprovalModalOpen(true)}
                    data-walkthroughid={walkthroughIds.ufPendingApproval}>
                    <Icon as={MdWarning} sx={{ boxSize: '24px' }} />
                    Pending Approval
                </ChakraButton>
            )}
            {showPendingApproval && requiredScope === 20 && (
                <>
                    <Icon as={MdDescription} sx={{ boxSize: '24px' }} />
                    Pending Approval
                </>
            )}
            <CompanyApprovalModal
                isOpen={isApprovalModalOpen}
                onClose={() => setIsApprovalModalOpen(false)}
                company={{ id: currentCompany, ...companyStatus }}
            />
        </>
    );
};

export default CompanyStatus;
